export default __webpack_public_path__ + "static/media/4.2a7e9f08.jpg";